// Matches Analytics::Constants::CV_WORK_ID, also exposed as Aedu.WorkConstants.CV_WORK_ID.
export const CV_WORK_ID = -1;

export const analyticsTabs = [
  { label: 'Overview', key: 'overview', path: 'overview' },
  { label: 'Readers', key: 'readers', path: 'readers' },
  {
    label: 'Profile visitors',
    key: 'profile_visitors',
    path: 'profile-visitors',
  },
  { label: 'Impact', key: 'impact', path: 'impact' },
  { label: 'Papers', key: 'documents', path: 'documents' },
  { label: 'CV', key: 'cv', path: `documents/${CV_WORK_ID}` },
  { label: 'Countries', key: 'countries', path: 'countries' },
  { label: 'Keywords', key: 'keywords', path: 'keywords' },
  { label: 'External Links', key: 'links', path: 'links' },
] as const;

export type AnalyticsTab = (typeof analyticsTabs)[number]['key'];
export type AnalyticsSourcePage = AnalyticsTab | 'reader_profiles';

export const analyticsTab = (pathname: string): AnalyticsTab | undefined => {
  if (/\/Analytics\/?$/i.test(pathname)) return 'overview';
  const suffix = (
    pathname.split('/activity/')[1] ?? pathname.match(/\/Analytics\/(.+)/i)?.[1]
  )?.replace(/\/$/, '');
  if (!suffix) return undefined;
  if (
    suffix.startsWith(`documents/${CV_WORK_ID}`) &&
    (suffix === `documents/${CV_WORK_ID}` ||
      suffix.startsWith(`documents/${CV_WORK_ID}/`))
  )
    return 'cv';
  return analyticsTabs.find(
    ({ path }) => suffix === path || suffix.startsWith(`${path}/`),
  )?.key;
};

export const analyticsLandingPath = (
  from?: AnalyticsSourcePage,
  trigger?: string,
): string => {
  const search = new URLSearchParams({ feature: 'analytics_dashboard' });
  if (from) search.set('analytics_page', from);
  if (trigger) search.set('trigger', trigger);
  return `/upgrade?${search}`;
};

export const analyticsSourcePage = (
  pathname: string,
): AnalyticsSourcePage | undefined =>
  /\/(?:activity\/)?readers\/profiles\/?$/.test(pathname)
    ? 'reader_profiles'
    : analyticsTab(pathname);
